const { TEXT_TRANSFORM } = require('../transformText/constants');

/**
 *  The default brand name text letters transformation
 * @type {String}
 */
const DEFAULT_BRAND_NAME_TEXT_TRANSFORM = TEXT_TRANSFORM.CAPITALIZE;

/**
 *  The default slogan text letters transformation
 * @type {String}
 */
const DEFAULT_SLOGAN_TEXT_TRANSFORM = TEXT_TRANSFORM.SENTENCE_CASE;

module.exports = {
    DEFAULT_SLOGAN_TEXT_TRANSFORM,
    DEFAULT_BRAND_NAME_TEXT_TRANSFORM
};
